<template>
  <div class="noti-dropdown" :style="dropdownStyle">
    <div class="header">Notifications</div>

    <div class="loading-container" v-if="isLoading">
      <img class="spinner" src="/themes/web/assets/images/icon/loadding.png" alt="" style="width: 30px;" />
    </div>

    <div v-else-if="!originNotiList?.length" class="no-noti" style="margin-top: 16px">
      No new notifications. Check back soon !
    </div>

    <div class="content" v-else @scroll.passive="handleScroll" ref="scrollContainer">
      <div class="noti-section">
        <p class="section-title">New</p>
        <div v-if="newNotiList?.length">
          <div v-for="item in newNotiList" :key="item.id">
            <div @click.stop="handleClick(item, true)">
              <notiItem :item="item"></notiItem>
            </div>
          </div>
        </div>
        <div v-else class="no-noti">
          No new notifications. Check back soon !
        </div>
      </div>

      <div class="noti-section" v-if="olderNotiList?.length">
        <p class="section-title">Older</p>
        <div v-for="item in olderNotiList" :key="item.id">
          <div @click.stop="handleClick(item)">
            <notiItem :item="item"></notiItem>
          </div>
        </div>
      </div>

      <div v-if="isLoadingMore" class="loading-container">
        <img class="spinner" src="/themes/web/assets/images/icon/loadding.png" alt="" style="width: 30px;" />
      </div>

    </div>

    <div class="row-center">
      <div v-if="originNotiList?.length && !isLoading" :class="enableMarkAll ? 'igs-btn' : 'igs-btn disable'"
        @click="readAllNotiIpl()">
        Mark all as read
      </div>
    </div>

    <notiValidateModal class="" ref="notiValidateModal"></notiValidateModal>
  </div>
</template>

<script>
import {
  getAllCourse,
  getFlexAsmData,
  getListNoti,
  getModule,
  getNaviData,
  getNotiCount,
  getNotiDetail,
  readAllNoti,
  readNoti,
} from "@/models/dashboard";
import notiItem from "./notiItem.vue";
import notiValidateModal from "./notiValidateModal.vue";

import moment from "moment-timezone";
import { isMobileDevice } from "@/firebase";
import { getCookie } from "@/APIGateWay";

const DATA_UNAVAILABLE = {
  title: "Data is not available",
  content: "Please contact your teacher for more details.",
};

export default {
  name: "ConfirmSubmit",
  components: { notiItem, notiValidateModal },
  props: {
    dropdownStyle: {
      type: Object,
      default: () => ({}),
    },
    isLoadData: {
      type: Boolean,
      default: true,
    },
    isGlobal: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isLoading: false,
    originNotiList: [],
    newNotiList: [],
    olderNotiList: [],
    isLoadingMore: false,
    stopLoadMore: false,
    take: 10,
    takeJump: 10,
    enableMarkAll: false,
    isHandlingClick: false,
    lstCourse: [],
    isLoginCase: null,
    normalNavigate: true,
    clickFromMobile: false,
  }),
  async created() {
    const token = getCookie("_wid");
    if (!token) {
      return;
    }

    await this.getListNotiIpl();
    await this.getNotiCountIpl();
    await this.getLstCourse();
    this.$emit('ready');
  },
  computed: {
    user_info() {
      return this.$store.state.user_info;
    },
  },

  mounted() {
    if (this.isGlobal) {
      window.addEventListener("flutter-notification", this.handleFlutterMessage);
      const savedNoti = localStorage.getItem("noti");
      if (savedNoti) {
        try {
          const message = JSON.parse(savedNoti);
          this.handleFlutterMessage({ detail: message });
        } catch (e) {
          console.error("Failed to parse saved noti:", e);
        }
      }
    }
  },
  beforeDestroy() {
    if (this.isGlobal) {
      window.removeEventListener(
        "flutter-notification",
        this.handleFlutterMessage
      );
    }
  },
  methods: {
    async handleFlutterMessage(e) {
      this.clickFromMobile = true;
      await this.getLstCourse();
      const message = e.detail;

      if (!message) return;

      if (!this.$store.state.user_info) {
        await this.$store.dispatch("SET_USER_INFO");
      }

      if (this.$store.state.user_info?.user_id == message?.userid) {
        this.getNotiDetailIpl(message?.id);
      }

      localStorage.removeItem("noti");
    },
    getNotiDetailIpl(notiId, loginCase) {
      if (loginCase) {
        this.isLoginCase = loginCase
      }
      this.normalNavigate = false;

      let toDate = moment.utc().format("YYYY-MM-DDTHH:mm:ss");
      let fromDate = moment
        .utc()
        .subtract(240, "days")
        .format("YYYY-MM-DDTHH:mm:ss");

      let params = {};

      params.Filter = {
        FromDate: fromDate,
        ToDate: toDate,
        NotificationId: notiId,
      };

      getNotiDetail(params)
        .then(async (response) => {
          let noti = response.data.Data;
          if (!noti) {
            await this.showNotiPopup(DATA_UNAVAILABLE.title, DATA_UNAVAILABLE.content);
            return;
          }
          const now = moment().tz(this.user_info?.timezone);
          const past24h = now.clone().subtract(24, "hours");

          const is24h = moment
            .utc(noti.SentAt)
            .tz(this.user_info?.timezone)
            .isAfter(past24h);
          await this.handleClick(noti, is24h);
        })
        .catch((err) => {
          console.log(
            "check user getNotiDetailIpl failed, please try again later.", err
          );
        })
        .finally(() => {
          this.normalNavigate = true;
        });
    },

    async getNotiCountIpl() {
      getNotiCount()
        .then((response) => {
          this.enableMarkAll = response?.data?.Data > 0;
        })
        .catch(({ response }) => {
          console.log(
            "check user getNotiCountIpl failed, please try again later."
          );
        });
    },
    readAllNotiIpl() {
      if (this.enableMarkAll) {
        readAllNoti()
          .then((response) => {
            this.getListNotiIpl();
            this.getNotiCountIpl();
            this.$emit("readAllNotiIpl");
          })
          .catch(({ response }) => {
            console.log(
              "check user readAllNotiIpl failed, please try again later."
            );
          });
      }
    },
    async handleClick(noti, isNew) {
      if (this.isHandlingClick) {
        return;
      }
      this.isHandlingClick = true;

      try {
        if (!noti.IsRead) {
          await this.readNotiIpl(noti.NotificationId);
          await this.getNotiCountIpl();

          let readItem = null;

          const list = isNew ? this.newNotiList : this.olderNotiList;

          readItem = list.find(
            (item) => item.NotificationId == noti.NotificationId
          );

          if (readItem) {
            readItem.IsRead = true;
          }

          this.$emit("readAllNotiIpl");
        }

        const type = noti.RefData.ObjectType;

        if (type !== "course" && this.normalNavigate && !(await this.isNotiAvailable(noti.NotificationId))) {
          await this.showValidatePopup(DATA_UNAVAILABLE.title, DATA_UNAVAILABLE.content);
          await this.getListNotiIpl();
          return;
        }

        if (type === "course") {
          await this.validateCourse(noti);
        } else if (type === "flex_assignment") {
          await this.validateFlexAsm(noti);
        } else if (["end_of_semester", "end_of_module"].includes(type)) {
          await this.getContentUrl(noti);
        } else {
          await this.navigateToContent(noti);
        }
      } catch (err) {
        console.error("Noti err:", err);
      } finally {
        this.isHandlingClick = false;
      }
    },
    async validateFlexAsm(noti) {
      let title = "";
      let content = "";

      return getFlexAsmData(noti.NavigationData.guid_ref)
        .then(async (response) => {
          let startDate = moment
            .utc(response.data.Data.StartDate)
            .tz(this.user_info?.timezone);

          const now = moment().tz(this.user_info?.timezone);

          const checkUnValid =
            response.data.Data.AssingmentStatus == "unpublished" ||
            now.isBefore(startDate) ||
            response.data.Data.StudentId == null;

          if (checkUnValid) {
            if (
              (response.data.Data.AssingmentStatus == "unpublished" &&
                now.isBefore(startDate)) ||
              response.data.Data.AssingmentStatus == "unpublished" ||
              response.data.Data.StudentId == null
            ) {
              title = "The flex assignment is not available";
              content =
                "This flex assignment might not be available anymore, or you may no longer be assigned to it. Please contact your teacher for more details.";
            } else {
              title = "The flex assignment has not started";
              content = "The flex assignment is coming soon. Check back later!";
            }

            await this.showNotiPopup(title, content);
            return;
          }

          let notiClone = {
            ...response.data.Data,
            Title: noti.Title,
          };

          this.navigateToContent(notiClone);
        })
        .catch(async () => {
          console.log(
            "check user validateFlexAsm failed, please try again later."
          );
          await this.showNotiPopup(DATA_UNAVAILABLE.title, DATA_UNAVAILABLE.content);
        });
    },
    async validateCourse(noti) {
      let hasAccess = await this.checkCourse(noti.NavigationData.class_id);

      if (hasAccess) {
        const path =
          "/subject/" +
          noti.NavigationData.course_id +
          "/" +
          noti.NavigationData.class_id;
        return await this.smartPush(path);
      } else {
        console.log("check user else validateCourse");
      }
    },
    async checkCourse(classId) {
      const showPopupAndReturnFalse = async (title, content) => {
        await this.showNotiPopup(title, content);
        return false;
      };

      const courseExist = this.lstCourse?.find(item => item.class_id == classId);

      if (courseExist) {
        if (!courseExist.is_started) {
          return await showPopupAndReturnFalse(
            "The course has not started",
            "The course is coming soon. Check back later!"
          );
        }
      } else {
        return await showPopupAndReturnFalse(
          "The course is not available",
          "This course may have ended or you may no longer be enrolled. Please contact your teacher for more details."
        );
      }

      return true;
    },
    // async checkCourse(classId) {
    //   let courseExist = this.lstCourse?.find(
    //     (item) => item.class_id == classId
    //   );

    //   if (courseExist) {
    //     if (!courseExist.is_started) {
    //       if (isMobileDevice(true)) {
    //         this.$router.push({ path: '/home' }).then(async () => {
    //           await this.showValidatePopup(
    //             "The course has not started",
    //             "The course is coming soon. Check back later!"
    //           );
    //         });
    //         return false;
    //       }
    //       await this.showValidatePopup(
    //         "The course has not started",
    //         "The course is coming soon. Check back later!"
    //       );
    //       return false;
    //     }
    //   } else {
    //     if (isMobileDevice(true)) {
    //       this.$router.push({ path: '/home' }).then(async () => {
    //         await this.showValidatePopup(
    //           "The course is not available",
    //           "This course may have ended or you may no longer be enrolled. Please contact your teacher for more details."
    //         );
    //       });
    //       return false;
    //     }
    //     await this.showValidatePopup(
    //       "The course is not available",
    //       "This course may have ended or you may no longer be enrolled. Please contact your teacher for more details."
    //     );
    //     return false;
    //   }
    //   return true;
    // },
    async getLstCourse() {
      const params = {
        grade_id: this.user_info?.grade_id,
        program_id: 0,
      };
      try {
        const response = await getAllCourse(params);
        this.lstCourse = response.data.results;
      } catch (err) {
        console.log("❌ getLstCourse failed:", err);
      }
    },
    // Push / login: show popup on Home ("Got it" stays on Home). Dropdown click: show popup in place.
    async showNotiPopup(title, content) {
      if (this.normalNavigate) {
        await this.showValidatePopup(title, content);
        return;
      }

      if (this.isLoginCase || this.$route.path !== '/home') {
        await this.$router.push({
          path: '/home',
          query: {
            popupTitle: title,
            popupContent: content
          }
        });
      } else {
        this.$root.$emit('show-popup', {
          title: title,
          content: content
        });
      }
    },
    // BE hides notifications whose item was deleted, so a missing detail means the item is gone.
    async isNotiAvailable(notiId) {
      try {
        const response = await getNotiDetail({
          Filter: {
            FromDate: moment.utc().subtract(240, "days").format("YYYY-MM-DDTHH:mm:ss"),
            ToDate: moment.utc().format("YYYY-MM-DDTHH:mm:ss"),
            NotificationId: notiId,
          },
        });
        return !!response?.data?.Data;
      } catch (err) {
        console.log("check user isNotiAvailable failed", err);
        return true;
      }
    },
    async showValidatePopup(title, content) {
      const cfm = await this.$refs.notiValidateModal.show({
        title: title,
        content: content,
      });

      if (!cfm) {
        return false;
      }
    },
    async handleScroll() {
      const el = this.$refs.scrollContainer;
      const bottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 80;

      if (bottom && !this.isLoadingMore && !this.stopLoadMore) {
        this.isLoadingMore = true;
        this.take += this.takeJump;
        this.getListNotiIpl(true);
      }
    },
    isFeedback(noti) {
      return (
        noti.Title.toLowerCase() == "New feedback".toLowerCase() ||
        noti.Title.toLowerCase() == "Feedback updated".toLowerCase()
      );
    },
    async smartPush(route) {
      if (isMobileDevice(true)) {
        let newRoute = route;

        if (typeof route === 'string') {
          const separator = route.includes('?') ? '&' : '?';
          newRoute = `${route}${separator}_ts=${Date.now()}`;
          if (this.clickFromMobile && !route.includes("clickFromMobile=true")) {
            newRoute += `&clickFromMobile=true`;
          }
        } else if (typeof route === 'object') {
          newRoute = {
            ...route,
            query: {
              ...(route.query || {}),
              _ts: Date.now(),
              ...(this.clickFromMobile ? { clickFromMobile: true } : {}),
            },
          };
        }

        this.clickFromMobile = false;
        return await this.$router.replace(newRoute);
      }
      return await this.$router.push(route);
    },

    async navigateToContent(noti) {
      let dataNavi = noti.NavigationData;
      let feedbackId = 0;

      if (noti.Title && this.isFeedback(noti)) {
        feedbackId = dataNavi.latest_feedback_id;
      }

      const targetRoute =
        "/lesson/" +
        dataNavi.class_id +
        "/" +
        dataNavi.course_id +
        "-" +
        dataNavi.module_id +
        "-" +
        dataNavi.lesson_id +
        "-" +
        dataNavi.lesson_package_id +
        "-" +
        dataNavi.course_item_id +
        "-" +
        feedbackId;

      let hasAccess = await this.checkCourse(dataNavi.class_id);

      if (hasAccess) {
        return await this.smartPush(targetRoute);
      } else {
        console.log("check user else navigateToContent", this.lstCourse);
      }
    },

    async getContentUrl(noti) {
      let data = noti.NavigationData;

      const params = {
        course_id: data.course_id,
        class_id: data.class_id,
      };

      return getModule(params)
        .then(async (response) => {
          let test = null;
          if (response.data.results) {
            let moduleList = response.data.results.modules;
            if (moduleList) {
              if (data.type_code == "end_of_semester") {
                test = moduleList.find(
                  (module) => module.id == data.test_id
                )?.semeter_test;
              } else {
                test = moduleList.find(
                  (module) => module.test?.id == data.test_id
                )?.test;
              }
            }
            let hasAccess = await this.checkCourse(data.class_id);
            if (hasAccess) {
              if (test) {
                return await this.smartPush({
                  name: "test_detail",
                  query: {
                    test: JSON.stringify(test),
                    type: data.type_code,
                    class_id: data.class_id,
                    course_id: data.course_id,
                    module_id: data.module_id,
                    ...(noti.Title &&
                      this.isFeedback(noti) && {
                      feedback_id: data.latest_feedback_id,
                    }),
                  },
                });
              } else {
                console.log("check user else getContentUrl");
                await this.showNotiPopup(DATA_UNAVAILABLE.title, DATA_UNAVAILABLE.content);
              }
            }
          }
        })
        .catch(() => {
          console.log(
            "check user getContentUrl failed, please try again later."
          );
        });
    },
    handleNotiList(originNotiList) {
      this.newNotiList = [];
      this.olderNotiList = [];
      const now = moment().tz(this.user_info?.timezone);
      const past24h = now.clone().subtract(24, "hours");
      originNotiList?.forEach((item) => {
        const is24h = moment
          .utc(item.SentAt)
          .tz(this.user_info?.timezone)
          .isAfter(past24h);
        if (is24h) {
          this.newNotiList.push(item);
        } else {
          this.olderNotiList.push(item);
        }
      });
    },
    async readNotiIpl(notificationId) {
      let params = {};

      params.Filter = [
        {
          NotificationId: notificationId,
        },
      ];

      return readNoti(params)
        .then((response) => { })
        .catch(({ response }) => {
          console.log("readNotiIpl failed, please try again later.");
        });
    },
    async getListNotiIpl(isLoadMore) {
      if (!isLoadMore) {
        this.isLoading = true;
      }

      let toDate = moment
        .utc()
        // .tz(this.user_info.timezone)
        .format("YYYY-MM-DDTHH:mm:ss");
      let fromDate = moment
        .utc()
        .subtract(240, "days")
        // .tz(this.user_info.timezone)
        .format("YYYY-MM-DDTHH:mm:ss");

      let params = {};

      params.Filter = {
        FromDate: fromDate,
        ToDate: toDate,
      };

      params.Take = this.take;

      return getListNoti(params)
        .then((response) => {
          this.originNotiList = response.data.Data;

          if (this.originNotiList.length < this.take) {
            this.stopLoadMore = true;
          }

          this.handleNotiList(this.originNotiList);
        })
        .catch(() => {
          console.log("getListNoti failed, please try again later.");
        })
        .finally(() => {
          this.isLoading = false;
          this.isLoadingMore = false;
        });
    },
  },
};
</script>

<style scoped>
.no-noti {
  font-size: 14px;
  color: #403d3d;
  text-align: center;
}

.content {
  overflow: auto;
  min-height: 14vh;
  max-height: 60vh;
  padding-right: 8px;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 16px;
}

.igs-btn {
  margin-top: 16px;
  height: 36px;
  width: fit-content;
  text-align: center;
  display: flex;
  align-items: center;
  justify-self: center;
}

.igs-btn.disable:active {
  top: 0 !important;
  left: 0 !important;
}

.igs-btn.disable {
  border: 1px solid var(--Cloud-Dark, #cfcfcf) !important;
  background: var(--Cloud-Light, #ddd) !important;
  box-shadow: 4px 4px 0px 0px #777777 !important;
  color: #777777 !important;
}

.header {
  color: #a560eb;
  font-size: 24px;
  font-weight: bold;
}

.noti-dropdown {
  right: 20px;
  width: 40vw;
  /* max-height: 50vh; */
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  padding: 16px;
  z-index: 999;
}

.noti-dropdown::-webkit-scrollbar {
  display: none;
}

.section-title {
  font-weight: 600;
  margin: 12px 0 8px;
  color: #777777;
}

.noti-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
  position: relative;
}

.noti-icon {
  width: 40px;
  height: 40px;
  margin-top: 2px;
}

.noti-content {
  flex: 1;
}

.title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.noti-content .title {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 2px;
  color: black;
}

.noti-content .desc {
  font-size: 13px;
  color: #555;
}

.noti-time {
  font-size: 12px;
  color: #03a9f4;
  white-space: nowrap;
}

.row-center {
  display: flex;
  width: 100%;
  justify-content: center;
}
</style>
